<template>
  <div>
    <LayoutHeaderWorks
      activeNav="比赛评选"
      :topColor="topColor"
      btnType="detail"
      :height="450"
    />
    <div class="container">
      <div class="repeatTitle">
        <div class="title_text art_info_line">
          <h1>上传参赛作品</h1>
          <h2>Upload entries</h2>
        </div>
      </div>

      <h1>参赛作品不可自行删除，上传作品后如需修改</h1>

      <a-form labelAlign="left">
        <a-form-item label="作品名称">
          <a-input
            style="width: 480px"
            v-model="form.name"
            type="text"
            placeholder=""
          >
          </a-input>
        </a-form-item>

        <a-form-item label="作者">
          <div style="color: #989898">
            多个参赛作者，请在姓名前加上职位分工，例如 导演：***
          </div>
          <div
            v-for="(input_item, input_index) in authorArr"
            :key="input_index"
            style="
              width: 200px;
              display: inline-block;
              position: relative;
              margin-right: 8px;
            "
          >
            <a-input
              style="padding-right: 30px"
              type="text"
              placeholder=""
              v-model="input_item.value"
            >
            </a-input>
            <img
              @click="deleteInput(input_index)"
              style="
                position: absolute;
                width: 20px;
                height: 20px;
                top: 18px;
                right: 10px;
                cursor: pointer;
              "
              src="../../assets/images/match/bm-bt-delete@2x.png"
              alt=""
            />
          </div>
          <img
            @click="addMore"
            style="
              width: 28px;
              height: 28px;
              margin-left: 22px;
              cursor: pointer;
            "
            src="../../assets/images/match/bm-icon-ADD1@2x.png"
            alt=""
          />
        </a-form-item>

        <div class="form_line"></div>

        <a-form-item class="workUpload" label="参赛作品">
          <div style="display: flex; flex-wrap: wrap">
            <a-upload-dragger
              accept=".png,.jpg"
              name="worksPic"
              :multiple="true"
              :customRequest="uploadPic"
              :before-upload="beforePicUpload"
            >
              <div v-if="uploading" class="progress">
                <a-progress type="circle" :percent="worksPicPercent" />
              </div>
              <div v-else class="workBanner"></div>
            </a-upload-dragger>
            <div
              style="margin-right: 20px; margin-bottom: 20px"
              v-for="(img_item, img_index) in worksPicArr"
              :key="img_index"
            >
			  <p class="aui_close" @click="delImg(img_index)">x</p>
              <img
                style="width: 320px; height: 240px"
                :src="img_item.url_full"
                alt=""
              />
			  
            </div>
          </div>
        </a-form-item>

        <div class="form_line"></div>

        <a-form-item label="上传音视频">
          <div style="color: #989898">
            最多上传/导入3个视频，单个视频不超过500M
            <input
              accept=".mp3,.ogg"
              ref="uploadAudioBtn"
              :multiple="true"
              @change="uploadAudio"
              style="display: none"
              type="file"
            />
            <input
              accept=".mp4,.webm"
              ref="uploadVideoBtn"
              :multiple="true"
              @change="uploadVideo"
              style="display: none"
              type="file"
            />
            <input
              accept=".pdf"
              ref="uploadPdfBtn"
              :multiple="true"
              @change="uploadPdf"
              style="display: none"
              type="file"
            />
            <div style="display: flex">
              <div @click="handleUploadAudio" class="uploadAudio">上传音频</div>
              <div @click="handleUploadVideo" class="uploadVideo">上传视频</div>
              <div @click="handleUploadPdf" class="uploadVideo" style="margin-left:10px;">上传pdf</div>
            </div>
            <ul>
              <li
                style="display: flex; justify-content: space-between"
                v-for="(media_item, media_index) in worksMediaArr"
                :key="media_index"
              >
                <span>{{ media_item.name }}</span>
                <span>{{ media_item.status }}</span>
              </li>
            </ul>
          </div>
        </a-form-item>

        <div class="form_line"></div>

        <a-form-item label="作品封面">
          <a-upload-dragger
            accept=".png,.jpg"
            name="file"
            :customRequest="uploadCover"
          >
            <img
              style="width: 320px; height: 240px"
              v-if="cover_img_full"
              :src="cover_img_full"
              alt=""
            />
            <div v-else class="coverBanner"></div>
          </a-upload-dragger>
        </a-form-item>

        <div class="form_line"></div>

        <a-form-item label="作品说明">
          <a-textarea
            style="resize: none; width: 660px"
            placeholder="为你的作品添加一段描述吧，有助于评审更好的理解作品"
            :auto-size="{ minRows: 6 }"
			:maxLength = "500"
            v-model="form.synopsis"
          />
        </a-form-item>

        <div class="form_line"></div>

        <a-form-item>
          <div class="uploadBtn" html-type="submit" @click="handleSubmit">
            确认上传
          </div>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import SliceUploadServices from "../../xx-vue/services/sliceUpload";
import OrdinaryUpload from "../../xx-vue/services/system";
import SystemServices from "../../xx-vue/services/system";
import WorksServices from "../../xx-vue/services/works";
export default {
  data() {
    return {
      topColor: "background-color: rgba(0, 0, 0, 0.3)",
      worksPicArr: [],
      worksMediaArr: [],
      uploading: false,
      worksPicPercent: 0,
      form: {},
      cover_img_full: "",
      worksPicArr_data: [],
      worksMediaArr_data: [],
      authorArr: [{ value: "" }],
      loading: false,
    };
  },
  mounted() {
    this.initScroll();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    //添加作者
    addMore() {
      this.authorArr.push({ value: "" });
    },
    //移除作者
    deleteInput(index) {
      this.authorArr = this.authorArr.filter((v, i) => i !== index);
    },
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //表单提交
    async handleSubmit(e) {
      e.preventDefault();
      let authorStr = "";
      this.authorArr.map((v, i) => {
        if (i !== this.authorArr.length - 1) {
          authorStr += v.value + ",";
        } else {
          authorStr += v.value;
        }
      });
      const data = {
        title: this.form.name,
        img: this.form.img,
        author: authorStr,
        synopsis: this.form.synopsis,
        annex: [...this.worksPicArr_data, ...this.worksMediaArr_data],
        project_id: ~~this.$route.query.project_id,
        group_id: ~~this.$route.query.group_id,
      };
      const result = await WorksServices.addWorkAsync(data);
      if (result.code === 200) {
        this.$message.success("上传成功！");
        this.$router.push(
          `/match/match_works?project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
        );
      } else {
        this.$message.error("上传失败！");
      }
    },
    //检测格式
    beforePicUpload(file) {
      // if (file.type === "image/jpeg" || file.type === "image/png") {
      //   //判断图片格式
      //   const picSize = file.size / 1024 / 1024;
      //   if (picSize > 10) {
      //     this.$message.error(`图片不能大于10MB`);
      //     return false;
      //   }
      // } else {
      //   this.$message.error(`请上传格式为jpg/png的图片`);
      //   return false;
      // }
    },
    //切片并上传_antd
    uploadPic(obj) {
      this.uploading = true;
      const file = obj.file;
      var start = 0,
        end = 0;
      var size_all = file.size;
      var percentage = 0;
      var i = 0;
      var limit = 10 * 1024; //每块文件大小
	  // if(size_all<=limit){
		 //  //调用普通上传
		 //  OrdinaryUpload.uploadPicAsync({"file" : obj}).then((res)=>{
			//   this.worksPicArr.push({
			//     annex_path: res.data.path,
			//     type: 0,
			//     url_full: res.data.path_full,
			//   });
		 //  }).catch(() => {});
		 //  return false;
	  // }
      var max_i = Math.ceil(size_all / limit) - 1;
      const suffixArr = file.name.split(".");
      const suffixLth = suffixArr.length - 1;
      const suffix = suffixArr[suffixLth];

      var cutIntoSilice = () => {
        var picData = new FormData();
        //切片

        // var f = file.slice(start, start + limit > end ? end : start + limit);
        start = i * limit;
        end = max_i == i ? size_all : (i + 1) * limit;
        var f = file.slice(start, end);
        picData.append("name", file.name);
        picData.append("file", f);
        picData.append("i", i);
        picData.append("uid", file.uid);
        picData.append("size", end - start);
        picData.append("size_all", size_all);
        picData.append("status", start == 0 ? 1 : max_i == i ? 2 : 0);
        picData.append("suffix", suffix);
        SliceUploadServices.uploadAsync(picData)
          .then((res) => {
            if (res.code === 200) {
              if (max_i != i) {
                i += 1;
                cutIntoSilice();
                this.worksPicPercent = parseInt((i / max_i) * 100);
              } else {
                this.uploading = false;
                this.worksPicArr.push({
                  annex_path: res.data.path,
                  type: suffix,
                  url_full: res.data.path_full,
                });
                this.worksPicArr_data.push({
                  annex_path: res.data.path,
                  type: 0,
                  name: file.name,
                });
              }
            }
          })
          .catch(() => {});
      };
      cutIntoSilice();
    },
	//删除上传图片作品
	delImg(index){
		this.worksPicArr.splice(index,1);
		if(img_list.length==0){
			this.uploading = false;
		}
	},
    //切片并上传_js
    uploadMedia(obj) {
      obj.map((v, index) => {
        var timestamp = new Date().getTime();
        const uid =
          timestamp +
          "" +
          this.getRandomInt(0, 999999999999) +
          "" +
          this.getRandomInt(0, 999999999999) +
          "" +
          this.getRandomInt(0, 999999999999);
        const file = v;
        var start = 0,
          end = 0;
        var size_all = file.size;
        var percentage = 0;
        var i = 0;
        var limit = 1000 * 1024; //每块文件大小
        var max_i = Math.ceil(size_all / limit) - 1;
        const suffixArr = file.name.split(".");
        const suffixLth = suffixArr.length - 1;
        const suffix = suffixArr[suffixLth];

        var cutIntoSilice = () => {
          var picData = new FormData();
          //切片
          // var f = file.slice(start, start + limit > end ? end : start + limit);
          start = i * limit;
          end = max_i == i ? size_all : (i + 1) * limit;
          var f = file.slice(start, end);
          picData.append("name", file.name);
          picData.append("file", f);
          picData.append("i", i);
          picData.append("uid", uid);
          picData.append("size", end - start);
          picData.append("size_all", size_all);
          picData.append("status", start == 0 ? 1 : max_i == i ? 2 : 0);
          picData.append("suffix", suffix);
          SliceUploadServices.uploadAsync(picData)
            .then((res) => {
              if (res.code === 200) {
                if (max_i != i) {
                  i += 1;
                  cutIntoSilice();
                } else {
                  this.worksMediaArr = this.worksMediaArr.map((v) => {
                    return {
                      ...v,
                      status: "上传成功",
                      type: suffix,
                      annex_path: res.data,
                      url_full: res.path_full,
                    };
                  });
                  if (suffix == "mp4" || suffix == "webm") {
                    this.worksMediaArr_data.push({
                      annex_path: res.data.path,
                      type: 1,
                      name: file.name,
					  url_full:res.data.path_full,
                    });
                  } else if(suffix == "mp3" || suffix=="ogg") {
                    this.worksMediaArr_data.push({
                      annex_path: res.data.path,
                      type: 2,
                      name: file.name,
                    });
                  }else {
                    this.worksMediaArr_data.push({
                      annex_path: res.data.path,
                      type: 3,
                      name: file.name,
                    });
                  }
                }
              }
            })
            .catch(() => {});
        };
        cutIntoSilice();
      });
    },
    //上传音频按钮
    handleUploadAudio() {
      this.$refs.uploadAudioBtn.click();
    },
    //上传视频按钮
    handleUploadVideo() {
      this.$refs.uploadVideoBtn.click();
    },
    //上传pdf
    handleUploadPdf() {
      this.$refs.uploadPdfBtn.click();
    },
    //触发上传音频
    uploadAudio() {
      let fileList = [];
      const obj = this.$refs.uploadAudioBtn.files;
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          fileList.push(obj[key]);
        }
      }

      if (fileList.length > 3) {
        this.$message.error("最多上传3个音频！");
      } else {
        fileList.map((v, i) => {
          if (v.size < 500 * 1024 * 1024) {
            if (i == fileList.length - 1) {
              this.uploadMedia(fileList);
              this.worksMediaArr = fileList.map((v) => {
                return { name: v.name };
              });
            }
          } else {
            this.$message.error(`音频大小不得大于500MB!`);
          }
        });
      }
    },
    //触发上传视频
    uploadVideo() {
      let fileList = [];
      const obj = this.$refs.uploadVideoBtn.files;
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          fileList.push(obj[key]);
        }
      }

      if (fileList.length > 3) {
        this.$message.error("最多上传3个视频！");
      } else {
        fileList.map((v, i) => {
          if (v.size < 500 * 1024 * 1024) {
            if (i == fileList.length - 1) {
              this.uploadMedia(fileList);
              this.worksMediaArr = fileList.map((v) => {
                return { name: v.name };
              });
            }
          } else {
            this.$message.error(`视频大小不得大于500MB!`);
          }
        });
      }
    },
    //触发上传pdf
    uploadPdf(){
        let fileList = [];
      const obj = this.$refs.uploadPdfBtn.files;
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          fileList.push(obj[key]);
        }
      }

      if (fileList.length > 3) {
        this.$message.error("最多上传3个pdf！");
      } else {
        fileList.map((v, i) => {
          if (v.size < 50 * 1024 * 1024) {
            if (i == fileList.length - 1) {
              this.uploadMedia(fileList);
              this.worksMediaArr = fileList.map((v) => {
                return { name: v.name };
              });
            }
          } else {
            this.$message.error(`pdf大小不得大于50MB`);
          }
        });
      }
      
    },
    //产生随机数
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    //上传封面
    async uploadCover(obj) {
      const formData = new FormData();
      formData.append("file", obj.file);
      const result = await SystemServices.uploadPicAsync(formData);
      console.log(result);
      this.form.img = result.data.path;
      this.cover_img_full = result.data.path_full;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}

/deep/ .workUpload .ant-form-item-children > span {
  display: inline-block;
}

/deep/ .ant-upload-list {
  display: none;
}

/deep/ .ant-form-item label {
  color: #656565;
}

/deep/ .ant-form-item-label {
  min-width: 100px;
}

/deep/ .workUpload .ant-form-item-children > div > span {
  margin-right: 20px;
}

/deep/ .workUpload .ant-form-item-control {
  margin-right: 20px;
}
.aui_close {
		width: 20px;
		height: 20px;
		line-height: 20px;
		display: block;
		position: relative;
		left:15px;
		top:30px;
		font-family: Helvetica, STHeiti;
		_font-family: '\u9ed1\u4f53', 'Book Antiqua', Palatino;
		font-size: 18px;
		border-radius: 20px;
		background: #999;
		color: #FFF;
		box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
		-moz-transition: linear .06s;
		-webkit-transition: linear .06s;
		transition: linear .06s;
		padding: 0;
		text-align: center;
		text-decoration: none;
		outline: none;
		cursor: pointer;
	}
	.aui_close:hover {
		color: #FFF;
		box-shadow: 0 1px 3px rgba(209, 40, 42, .5);
		background: #d1282a;
		border-radius: 24px;
		transition: all 0.2s ease-out;
		opacity: 0.8;
	}
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;

  .repeatTitle {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;

    .title_text {
      text-align: center;
      background: url("../../assets/images/index/title-line1@2x.png") no-repeat
        68px 0px;
      background-size: contain;
      padding: 10px;
    }

    .art_info_line {
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2left@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        left: -500px;
        top: 34px;
      }

      &::before {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2right@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        right: -500px;
        top: 34px;
      }
    }

    h1 {
      font-size: 26px;
      padding-top: 6px;
    }

    h2 {
      font-size: 14px;
      color: #989898;
      font-weight: normal;
    }
  }

  & > h1 {
    font-weight: normal;
    color: #a77272;
    font-size: 14px;
    text-align: center;
    margin-bottom: 68px;
  }

  .form_line {
    width: 100%;
    height: 1px;
    background-color: #dddddd;
    margin: 26px 0;
  }

  .ant-upload.ant-upload-select-picture-card {
    background-color: unset;
    border: none;
  }
  .ant-upload.ant-upload-select-picture-card > .ant-upload {
    padding: 0;
    display: flex;
    align-items: center;
  }
  .ant-upload-picture-card-wrapper {
    width: 135px;
  }
  .ant-input {
    border: none;
    height: unset;
    background-color: #f6f6f6;
    padding-top: 14px;
    padding-bottom: 14px;
    font-size: 18px;
    color: #989898;
    text-indent: 10px;
  }
  .ant-select-selection--single {
    color: #989898;
    height: unset;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 12px;
  }

  .ant-cascader-picker {
    border: 1px solid #e6e7e8;
    width: 240px;
    color: #989898;
  }

  .ant-calendar-picker-input.ant-input {
    width: 240px;
    background-color: white;
    border: 1px solid #e6e7e8;
  }

  .ant-form-item {
    display: flex;
  }

  .workBanner {
    width: 320px;
    height: 240px;
    background: url("../../assets/images/match/tpsc.png") no-repeat;
    background-size: 100% 100%;
  }

  .progress {
    width: 320px;
    height: 240px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .coverBanner {
    width: 320px;
    height: 240px;
    background: url("../../assets/images/match/FMSC.png") no-repeat;
    background-size: 100% 100%;
  }

  .uploadAudio {
    width: 120px;
    height: 48px;
    background: url("../../assets/images/match/bs-button-normol@2x.png")
      no-repeat;
    background-size: 100% 100%;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
    color: white;
    margin-right: 10px;
  }

  .uploadVideo {
    width: 120px;
    height: 48px;
    background: url("../../assets/images/match/bs-button-normol@2x.png")
      no-repeat;
    background-size: 100% 100%;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
    color: white;
  }

  .uploadBtn {
    width: 240px;
    height: 48px;
    margin-left: 100px;
    background: url("../../assets/images/match/bm-bt-submit2@2x.png") no-repeat;
    background-size: 100% 100%;
    color: white;
    font-size: 14px;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
  }
}
</style>